export enum ScheduleType {
  AMBULATORY = 'ambulatory',
  SURGICAL = 'surgical'
}

export enum ScheduleTypeTitle {
  AMBULATORY = 'Consulta',
  SURGICAL = 'Cirurgia'
}
